module.exports = (parcelRequire.load("7HkY3")).then(() => parcelRequire('jqV1o'));